import Vue from 'vue'
import wuwei from 'packages/index'
import { cate } from 'packages/components/constants/types'
import controlList from './controlList.js'
import helpers from 'hexyun.helpers'

const getComponent = function() {
  let n = 0
  return function(comp) {
    const prefix = 'com'
    n++
    comp._id = `${prefix}${n}`
    comp.name = `${comp.name}${n}`
    comp.cate = cate
    return comp
  }
}()

const cacheComponent = Object.keys(wuwei).reduce((l, p) => {
  const t = wuwei[p]
  if(t.define && t.name) {
    t.type = t.name
    t.define.type = t.type
    t.define.cate = cate
    t.define.template = getTemplate(t.define, true, true)
    l.defines[t.name] = t.define
    l.components[t.name] = t
    return l
  }
  return l
}, {
  defines: {},
  components: {}
})
// console.log('cacheComponent', cacheComponent)
const autoConf = treeList => {
  const __autoConf = function(item) {
    if(item.lists && item.lists.length > 0) {
      item.list.map(__autoConf)
    } else {
      getComponent(item)
    }
  }
  for(let id in treeList) {
    let lists = treeList[id].lists
    if(lists && lists.length) __autoConf(lists)
  }
  return treeList
}
const controlMenus = autoConf(controlList)
// 根据define自动生成template
function getTemplate (control, isPanel = false, isDefine = false) {
  {
    let define
    if(isDefine) {
      define = control
    } else {
      define = cacheComponent.defines[control.type]
      return define.template
    }
    const keyFn = k => `control.props['${k}']`
    let {attrs, slots} = helpers.control.process(define, control.props, keyFn)
    // console.log(attrs)
    // 如果是面板上添加resize
    let resizeTmpl = '', slotTmpl = ''
    if(isPanel) {
      resizeTmpl = `<resize v-if="selected" :control="control"></resize>`
    }
    return `
  <div #ID# #hook# :style="positionStyle()">
      <${control.type} ${attrs.join(' ')} :st='propStyle()'>
           ${slots}
</${control.type}>
      ${resizeTmpl}
  </div>
`
  }
}
const getCompProps = function(comp, define) {
  const c = cacheComponent.components[comp]
  if(!c) {
    console.warn(`[${comp}]不存在，请组件是否存在`)
    return null
  } else {
    return define ? c[define] : c
  }
}

export {
  cacheComponent,
  getCompProps,
  controlMenus,
  getTemplate
}



// WEBPACK FOOTER //
// ./src/constant/controlMenus.js